import './components/completion_progress';
import './components/finish';
import './components/finish_to_ils_experiment';
import './components/form';
import './index.scss';
import 'components/select';
import 'pages/questions/components/onboarding_modal';
import ModalManager from 'utils/modal_manager';
import { EventManager } from 'utils/event_manager'; // so component is subscribed when event is published
import { setupProductStep } from 'components/modals/configure_account/components/products';

class ConfigureAccount {
  constructor() {
    this.$context = $('#js-configure-account');
    this.$currentUserSelector = $('#js-current-user');
    this.$steps = $('.step', this.$context);
    this.$productItem = $('.q-product-item', this.$context);
    this.$productTypes = $('.q-product-types', this.$context);
    this.$qselect = $('.q-select-input', this.$context);

    this._currentStep = 0;
    this._currentProduct = null;

    if (!this.$context.get(0)) {
      return;
    }

    this.bindOptions();
    this.bindSteps();
    this.bindForm();
    this.bindLinks();

    this.products = this.$productTypes.data('products');
    this.userPreferences = null;
    this.product_url = null;
  }

  open() {
    if (!this.$context.get(0)) {
      return;
    }
    ModalManager.open(this.$context);
    window.UserTracker.emit('event', {
      eventName: 'account setup started'
    });
  }

  getProduct = key => {
    return this.products.find(item => item.key === key);
  };

  getProductId = key => {
    const product = this.getProduct(key);
    return product?.id;
  };

  validateInput = () => {
    const $select = this.$context.find('.q-select-input:visible');

    $select.qselect('on', 'change', () => {
      const $fieldsWithValue = $select.filter((i, el) => {
        const value = $(el).qselect('getValue');

        return Array.isArray(value)
          ? value.filter(Boolean).length > 0
          : value !== '';
      });

      const isDisabled = $select.length !== $fieldsWithValue.length;

      $('.js-next-step').prop('disabled', isDisabled);
    });
  };

  bindForm = () => {
    $('form#set-preferences-user-form', this.$context).on('submit', async e => {
      e.preventDefault();

      const user_preferences = {
        chose_product: true,
        preferred_product_id: this.getProductId(this.idKey),
        experience: this.experience
      };

      if (!this.isEnemVestibular && !this.isOab) {
        user_preferences.preferred_administrative_levels_attributes =
          this.administrativeLevels;
      }

      try {
        await Thor.UserPreference.update(
          {},
          {
            data: { user_preferences }
          }
        );

        toastr.success('Preferências salvas com sucesso!');

        if (this.careerLabels) {
          this.$currentUserSelector.attr(
            'data-carrers',
            this.careerLabels.join(', ')
          );
        }

        this.$currentUserSelector.attr(
          'data-previous-experience',
          this.experience
        );

        const payload = this.isEnemVestibular
          ? {
              career: 'enem',
              segment: this.segmentKey,
              'school type': this.schoolTypes,
              'degree course': this.degreeCourses,
              'college type': this.collegeTypes
            }
          : {
              career: this.careerLabels,
              segment: this.segmentKey,
              'previous experience': this.experience
            };

        window.UserTracker.identify(payload);
        window.UserTracker.emit('event', {
          eventName: 'account setup preferences setted',
          data: payload
        });

        this.step += 1;
        this.userPreferences = user_preferences;
        this.setProductUrl(
          this._currentProduct.key,
          user_preferences.preferred_product_id
        );
      } catch (ex) {
        const message =
          'Tivemos um problema ao tentar enviar suas preferências!';

        toastr.error(message);
        Rollbar.error(message, ex);
        this.step += 1;
      }
    });
  };

  bindSteps = () => {
    $('.js-prev-step')
      .off('click.steps')
      .on('click.steps', () => {
        this.resetProductSelection();
        this.step -= 1;
      });

    $('.js-next-step')
      .off('click.steps')
      .on('click.steps', () => {
        if (this.step === 1) {
          $('form#set-preferences-user-form').trigger('submit');
        } else {
          this.step += 1;
        }
      });
  };

  bindLinks = () => {
    $('.js-setup-completed', this.$context).on('click', e => {
      const href = e.currentTarget.dataset.href;
      const action = e.currentTarget.dataset.label;

      const payload = {
        'first action chosen': action,
        career: this.careerLabels,
        segment: this.isEnemVestibular ? 'enem' : this.segmentKey
      };

      if (!this.isEnemVestibular) {
        payload['previous experience'] = this.experience;
      }

      window.UserTracker.emit('event', {
        eventName: 'account setup completed',
        data: payload
      });

      if (action === 'questions') {
        window.Turbolinks.visit(this.product_url + this.applyFilters());
      }

      if (href) {
        if (href.includes('app')) {
          window.location.assign(href);
        }
        window.Turbolinks.visit(href);
      }
    });

    $('.js-setup-completed-search', this.$context).on('click', () =>
      EventManager.publish('modal_setup.search')
    );
  };

  getAdministrativeLevelIds = () => {
    return $.map(
      this.userPreferences['preferred_administrative_levels_attributes'],
      key => {
        return key['administrative_level_id'];
      }
    );
  };

  getAdministrativeLevelParams = () => {
    let url = '';

    this.getAdministrativeLevelIds().forEach(id => {
      url += `&administrative_level_ids%5B%5D=${id}`;
    });

    return url;
  };

  applyFilters = () => {
    const isBeginnerExperiment = $('.js-setup-completed-search').data(
      'beginner'
    );
    const CONCURSOS = 1,
      MILITAR = 5;
    const excludeFilters = '?exclude_nullified=true&exclude_outdated=true';
    const beginnerFilters = '&difficulty%5B%5D=1&difficulty%5B%5D=2';
    const shouldApplyFilters = [CONCURSOS, MILITAR].includes(
      this.userPreferences.preferred_product_id
    );
    const filters = shouldApplyFilters
      ? this.getAdministrativeLevelParams()
      : '';

    if (
      this.experience === 'beginner' &&
      this.segmentKey === 'concursos' &&
      isBeginnerExperiment
    ) {
      return `${excludeFilters}${filters}${beginnerFilters}`;
    }

    return `${excludeFilters}${filters}`;
  };

  setProductUrl = (key, product_id) => {
    const enem_vestibulares = product_id === 3 ? 'do-enem' : 'de-vestibular';
    const product_slug = {
      militares: '/questoes-militares/questoes',
      concursos: '/questoes-de-concursos/questoes',
      oab: '/questoes-da-oab/questoes',
      enem_vestibulares: `/questoes-${enem_vestibulares}/questoes`
    };

    this.product_url = product_slug[key];
  };

  bindOptions = () => {
    this.$productItem
      .off('click.selectContest')
      .on('click.selectContest', e => {
        this.product = e.currentTarget;
      });
  };

  resetProductSelection = () => {
    this._currentProduct = null;
    this.$productItem.removeClass('active');
    $('.js-next-step', this.$context).prop('disabled', true);
  };

  configureSecondStep = () => {
    const $defaultFields = $('#js-configure-account-default-fields');
    const $enemVestibularFields = $(
      '#js-configure-account-enem-vestibular-fields'
    );

    if (this.isEnemVestibular) {
      $defaultFields.addClass('hidden');
      $enemVestibularFields.removeClass('hidden');
    } else {
      $defaultFields.removeClass('hidden');
      $enemVestibularFields.addClass('hidden');

      const showSingle = this._currentProduct.key === 'enem_vestibulares';

      this.configureInput(
        `#first_option_${showSingle ? 'single' : 'multiple'}`
      );
      this.configureInput('#second_option_single');
    }

    $('.js-next-step').prop('disabled', true);

    this.validateInput();
  };

  configureInput(selector) {
    const $select = this.$qselect.parent().find(selector);
    const $parent = $select.parent();
    const key = selector.replace(/_single|_multiple|#/g, '');

    if (!this._currentProduct.form[key]) {
      $parent.addClass('hide');
    } else {
      $parent.removeClass('hide');
      const { label, options } = this._currentProduct.form[key];

      $parent.find('label').html(label);
      $select.qselect('enable').qselect('setOptions', options);
    }
  }

  toggleFirstOption = ({ key }) => {
    if (key === 'enem_vestibulares') {
      $('#first_option_single', this.$context).removeClass('hide');
      $('#first_option_multiple', this.$context).addClass('hide');
    } else {
      $('#first_option_single', this.$context).addClass('hide');
      $('#first_option_multiple', this.$context).removeClass('hide');
    }
  };

  get step() {
    return this._currentStep;
  }

  set step(value) {
    this.$steps.removeClass('show');
    this.$steps.eq(value).addClass('show');

    $('.js-prev-step', this.$context)
      .prop('disabled', value !== 1)
      .toggleClass('hide', value !== 1);

    if (value === 1) {
      this.configureSecondStep();
    }

    $('.modal-footer', this.$context).toggleClass('hide', value === 2);

    this._currentStep = value;
  }

  set product(el) {
    this.$productItem.removeClass('active');
    el.classList.add('active');

    const item = $(el).data('item');
    this.$qselect.qselect('reset');

    $('.js-next-step', this.$context).prop('disabled', false);

    this._currentProduct = item;
    this.toggleFirstOption(item);
  }

  get isEnemVestibular() {
    return this._currentProduct.key === 'enem_vestibulares';
  }

  get isOab() {
    return this._currentProduct.key === 'oab';
  }

  get idKey() {
    return this.isEnemVestibular ? 'enem' : this._currentProduct.key;
  }

  get firstSelects() {
    return (this._firstSelects =
      this._firstSelects ||
      Array.from(this.$context.find('.q-select-input:visible')));
  }

  get careerLabels() {
    if (this.isOab || this.isEnemVestibular) {
      return null;
    }

    const [firstSelect] = this.firstSelects;
    const careerOptions = this.isEnemVestibular
      ? []
      : $(firstSelect).qselect('getOptions');

    return $(firstSelect)
      .qselect('getValue')
      .map(val => careerOptions.find(opt => opt.value === val).label);
  }

  get experience() {
    const [firstSelect, secondSelect] = this.firstSelects;

    return this.isEnemVestibular
      ? 'beginner'
      : $(this.isOab ? firstSelect : secondSelect).qselect('getValue');
  }

  get segmentKey() {
    return this.getProduct(this.idKey).key;
  }

  get schoolTypes() {
    return $('#school_type').qselect('getValue');
  }

  get degreeCourses() {
    return $('#degree_course').qselect('getValue');
  }

  get collegeTypes() {
    return $('#college_type').qselect('getValue');
  }

  get administrativeLevels() {
    const [firstSelect] = this.firstSelects;
    const values = $(firstSelect).qselect('getValue');

    return values.reduce((prev, value, index) => {
      return {
        ...prev,
        [index]: { administrative_level_id: value }
      };
    }, {});
  }
}

(() => {
  document.addEventListener('turbolinks:load', function () {
    const modal = gon.flags?.modal_signup;

    if (modal) {
      setupProductStep();
      const configureAccountModal = new ConfigureAccount();
      configureAccountModal.open();
    }
  });
})();
